import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";
import { useKeenSlider } from "keen-slider/react";
import React from "react";

type Employee = {
  name: string;
  description: string;
  image: string;
  role: string;
};

interface Props {
  employees: Employee[];
}

export function EmployeeCarousel({ employees }: Props) {
  const [sliderRef, sliderInstance] = useKeenSlider({
    mode: "snap",
    loop: true,
    slides: {
      spacing: 40,
      perView: 1,
    },
  });

  return (
    <div className="space-y-4 lg:space-y-8">
      <div ref={sliderRef} className="keen-slider">
        {employees.map((employee, i) => (
          <EmployeeCard key={i} {...employee} />
        ))}
      </div>

      <div className="flex items-center justify-between">
        <button
          onClick={() => sliderInstance.current?.prev()}
          aria-label="Next slide"
          type="button"
          className="bg-cypress-800 hover:bg-cypress-500 flex h-12 w-12 items-center justify-center rounded-full p-2 text-white"
        >
          <IconChevronLeft aria-hidden />
        </button>
        <button
          onClick={() => sliderInstance.current?.next()}
          aria-label="Previous slide"
          type="button"
          className="bg-cypress-800 hover:bg-cypress-500 flex h-12 w-12 items-center justify-center rounded-full p-2 text-white"
        >
          <IconChevronRight aria-hidden />
        </button>
      </div>
    </div>
  );
}

function EmployeeCard({ name, image, description, role }: Employee) {
  return (
    <div className="bg-cypress-800 keen-slider__slide flex overflow-hidden rounded-2xl rounded-tl-[80px] max-lg:flex-col max-sm:rounded-tr-none">
      <img src={image} alt={name} className="h-[436px] object-cover" />

      <div className="lg:px-15 my-auto px-6 py-9 text-white">
        <h3 className="font-maison-extended mb-2 text-2xl font-bold sm:text-5xl">
          {name}
        </h3>
        {role && <div className="display-xl">{role}</div>}
        <p className="mt-6">{description}</p>
      </div>
    </div>
  );
}
